import MapboxCredits from 'components/Maps/MapboxCredits';
import Image from 'components/Image';
import itineraryMapboxUrl from 'helpers/itineraryMapboxUrl';

export default function ItineraryMap({
  itinerary,
  locationDetails,
  useBbox,
  width,
  rounding,
}) {
  return (
    <div className="tw-min-h-[297px] sm:tw-min-h-[303px] 2xl:tw-min-h-[400px]">
      <Image
        alt={`${itinerary.title} map`}
        src={itineraryMapboxUrl(itinerary, locationDetails, useBbox, width)}
        // width={455}
        // height={400}
        layout="fill"
        className={
          'tw-overflow-hidden tw-object-cover sm:tw-object-contain tw-object-center sm:tw-object-top' +
          (rounding === 0 ? '' : ` tw-rounded-${rounding || ''}xl`)
        }
      />
      <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-full">
        <div className="tw-absolute tw-bottom-0 tw-text-center tw-w-full">
          <MapboxCredits />
        </div>
      </div>
    </div>
  );
}
